(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }
 
  window.DNB.register(function () {
    var parseValue = function (text) {
      var cleaned = text.trim();
      var number = parseFloat(cleaned.replace(/[^0-9.]/g, ""));
      var suffix = cleaned.replace(/[0-9.]/g, "");
      return { number: number, suffix: suffix };
    };

    var getStoredTarget = function (el) {
      if (el.dataset.countupTargetNumber) {
        return {
          number: parseFloat(el.dataset.countupTargetNumber),
          suffix: el.dataset.countupTargetSuffix || ""
        };
      }

      var parsed = parseValue(el.textContent);
      if (isNaN(parsed.number)) {
        return null;
      }

      el.dataset.countupTargetNumber = String(parsed.number);
      el.dataset.countupTargetSuffix = parsed.suffix;
      return parsed;
    };

    var getDurationForTarget = function (targetNumber) {
      var minDuration = 2.6;
      var maxDuration = 4.6;
      var clamped = Math.max(0, Math.min(targetNumber, 200));
      var ratio = clamped / 200;
      return maxDuration - (maxDuration - minDuration) * ratio;
    };

    var animateValue = function (el) {
      if (!el || el.dataset.countupAnimated === "true") {
        return;
      }

      var target = getStoredTarget(el);
      if (!target || isNaN(target.number)) {
        return;
      }

      el.dataset.countupAnimated = "true";

      var textEl = el.querySelector(".dnb-reveal__inner") || el;
      var state = { value: 0 };

      if (window.gsap) {
        window.gsap.to(state, {
          value: target.number,
          duration: getDurationForTarget(target.number),
          ease: "power4.out",
          onUpdate: function () {
            textEl.textContent = Math.round(state.value) + target.suffix;
          }
        });
      } else {
        textEl.textContent = target.number + target.suffix;
      }
    };

    var initMarquee = function () {
      if (!window.gsap) {
        return;
      }

      var marquees = document.querySelectorAll("[data-infinite-text]");
      if (!marquees.length) {
        return;
      }

      marquees.forEach(function (marquee) {
        if (marquee.dataset.aboutMarqueeReady === "true") {
          return;
        }
        marquee.dataset.aboutMarqueeReady = "true";

        var textRows = marquee.querySelectorAll(".portfolio__marquee-text");
        if (!textRows.length) {
          return;
        }

        window.gsap.set(textRows, { xPercent: 0 });

        var tl = window.gsap.to(textRows, {
          xPercent: -50,
          duration: 20,
          ease: "none",
          repeat: -1
        });

        if (!window.ScrollTrigger) {
          return;
        }

        var triggerConfig = {
          trigger: marquee,
          start: "top 85%",
          end: "bottom 15%",
          invalidateOnRefresh: true,
          onUpdate: function (self) {
            tl.timeScale(self.direction === 1 ? 1 : -1);
          }
        };

        if (window.DNB && window.DNB.scroller) {
          triggerConfig.scroller = window.DNB.scroller;
        }

        window.ScrollTrigger.create(triggerConfig);
      });
    };

    var initFigures = function () {
      var section = document.querySelector(".figures");
      if (!section || section.dataset.figuresReady === "true") {
        return;
      }
      section.dataset.figuresReady = "true";

      var items = Array.prototype.slice.call(section.querySelectorAll(".figures__item"));
      if (!items.length) {
        return;
      }

      if (window.gsap) {
        window.gsap.set(items, { autoAlpha: 0, y: 48 });
      }

      var values = section.querySelectorAll("[data-countup-value]");
      values.forEach(function (valueEl) {
        var target = getStoredTarget(valueEl);
        if (!target) {
          return;
        }
        valueEl.textContent = "0" + target.suffix;
      });

      var animateItemValues = function (item) {
        var itemValues = item.querySelectorAll("[data-countup-value]");
        if (!itemValues.length) {
          return;
        }

        var runCountup = function () {
          itemValues.forEach(function (valueEl) {
            animateValue(valueEl);
          });
        };

        if (window.DNB && typeof window.DNB.revealText === "function" && window.gsap) {
          var revealTimeline = window.DNB.revealText(itemValues, {
            stagger: 0.08,
            duration: 1.4,
            ease: "expo.out"
          });

          if (revealTimeline) {
            revealTimeline.call(runCountup, null, 0.5);
          } else {
            runCountup();
          }
        } else {
          runCountup();
        }
      };

      var played = false;
      var playSequence = function () {
        if (played) {
          return;
        }
        played = true;

        if (window.gsap) {
          items.forEach(function (item, index) {
            window.gsap.to(item, {
              autoAlpha: 1,
              y: 0,
              duration: 0.7,
              delay: index * 0.18,
              ease: "power3.out",
              onStart: function () {
                animateItemValues(item);
              }
            });
          });
        } else {
          items.forEach(function (item) {
            item.style.opacity = "1";
            item.style.transform = "none";
            animateItemValues(item);
          });
        }
      };

      if (window.gsap && window.ScrollTrigger) {
        var triggerConfig = {
          trigger: section,
          start: "top 50%",
          once: true, 
          onEnter: playSequence
        };

        if (window.DNB && window.DNB.scroller) {
          triggerConfig.scroller = window.DNB.scroller;
        }

        window.ScrollTrigger.create(triggerConfig);
      } else if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                playSequence();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );

        observer.observe(section);
      } else {
        playSequence();
      }
    };

    var initHowItWorks = function () {
      var section = document.querySelector(".how-it-works");
      if (!section || section.dataset.howItWorksReady === "true") {
        return;
      }
      section.dataset.howItWorksReady = "true";

      var items = Array.prototype.slice.call(
        section.querySelectorAll("[data-how-it-works-item]")
      );
      if (!items.length) {
        return;
      }

      var updateDetailHeights = function () {
        items.forEach(function (item) {
          var detail = item.querySelector("[data-how-it-works-detail]");
          if (!detail) {
            return;
          }

          item.style.setProperty("--how-extra-height", detail.scrollHeight + "px");
        });
      };

      updateDetailHeights();
      window.addEventListener("resize", updateDetailHeights);

      var hasPlayedEnter = false;
      var playEnterSequence = function () {
        if (hasPlayedEnter) {
          return;
        }
        hasPlayedEnter = true;

        if (window.gsap) {
          items.forEach(function (item, index) {
            window.gsap.to(item, {
              delay: index * 0.16,
              keyframes: [
                {
                  autoAlpha: 1,
                  y: -60,
                  duration: 0.55,
                  ease: "power3.out"
                },
                {
                  y: 0,
                  duration: 0.42,
                  ease: "power2.out"
                }
              ]
            });
          });
          return;
        }

        items.forEach(function (item, index) {
          window.setTimeout(function () {
            item.style.transition =
              "opacity 0.55s ease, transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)";
            item.style.opacity = "1";
            item.style.transform = "translateY(-60px)";

            window.setTimeout(function () {
              item.style.transition = "transform 0.42s cubic-bezier(0.33, 1, 0.68, 1)";
              item.style.transform = "translateY(0)";
            }, 560);
          }, index * 140);
        });
      };

      if (window.gsap) {
        window.gsap.set(items, { autoAlpha: 0, y: 100 });
      } else {
        items.forEach(function (item) {
          item.style.opacity = "0";
          item.style.transform = "translateY(100px)";
          item.style.willChange = "transform, opacity";
        });
      }

      if (window.gsap && window.ScrollTrigger) {
        var triggerConfig = {
          trigger: section,
          start: "top 50%",
          once: true,
          onEnter: playEnterSequence
        };

        if (window.DNB && window.DNB.scroller) {
          triggerConfig.scroller = window.DNB.scroller;
        }

        window.ScrollTrigger.create(triggerConfig);
      } else if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                playEnterSequence();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.25 }
        );

        observer.observe(section);
      } else {
        playEnterSequence();
      }

      if (
        typeof window.matchMedia === "function" &&
        window.matchMedia("(hover: none), (pointer: coarse)").matches
      ) {
        var closeAll = function () {
          items.forEach(function (item) {
            item.classList.remove("is-active");
          });
        };

        items.forEach(function (item) {
          item.addEventListener("click", function () {
            var willOpen = !item.classList.contains("is-active");
            closeAll();
            if (willOpen) {
              item.classList.add("is-active");
            }
          });
        });

        document.addEventListener("click", function (event) {
          if (!section.contains(event.target)) {
            closeAll();
          }
        });
      }
    };

    initMarquee();
    initFigures();
    initHowItWorks();
  });
})();
